// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router';
import { getBrandDomainByHostname } from '@shared/environment';
import type { LanguageId } from '@shared/ui-kit/providers/translation-provider/i18next-config';
import { useTranslation } from 'react-i18next';
import { useAuthData } from '../../providers/auth-provider';
import { resolvePostLoginRedirect } from '../../utils/post-login-redirect';

export const useLanding = () => {
  const { login } = useAuthData();

  const { t, i18n } = useTranslation();

  const language = useMemo(() => i18n.language as LanguageId, [i18n.language]);

  const domain = useMemo(
    () =>
      typeof window === 'undefined'
        ? 'citec'
        : getBrandDomainByHostname(window.location.hostname),
    [],
  );

  const [searchParams] = useSearchParams();

  const postLoginRedirect = resolvePostLoginRedirect(
    searchParams.get('redirect-uri'),
  )?.token;

  const onLogin = useCallback(
    () => login('login', postLoginRedirect),
    [login, postLoginRedirect],
  );
  const onSignUp = useCallback(
    () => login('signup', postLoginRedirect),
    [login, postLoginRedirect],
  );

  return { onLogin, onSignUp, language, domain, t };
};
